module.exports = __webpack_public_path__ + "logo-orkla-gray-9d09dc3e58bf54e7dfa7b254447d0108.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-gray.svg
// module id = 58
// module chunks = 0